import { cn } from '@/lib/utils';
import { type Company } from '@/types';
import { Link } from '@inertiajs/react';
import { ArrowUpRight, Building2 } from 'lucide-react';

interface InlineCompanyCellProps {
    company?: Company | null;
    onUpdate?: (companyId: string | null) => void;
    className?: string;
}

export function InlineCompanyCell({ company, className }: InlineCompanyCellProps) {
    if (!company) {
        return (
            <div className={cn('text-muted-foreground px-2 py-1.5 text-sm', className)}>
                <span className="italic">No company</span>
            </div>
        );
    }

    return (
        <Link
            href={`/company/${company.id}`}
            onClick={(e) => e.stopPropagation()}
            className={cn(
                'hover:bg-accent rounded px-2 py-1.5 transition-colors',
                'group relative flex items-center gap-2 text-sm',
                'max-w-[150px] truncate',
                className,
            )}
        >
            <span className={cn('absolute -top-1 right-1.5 opacity-0 transition-opacity', 'group-hover:opacity-100')} aria-hidden="true">
                <ArrowUpRight className="text-muted-foreground h-3.5 w-3.5" />
            </span>
            <Building2 className="text-muted-foreground h-4 w-4 shrink-0" />
            <span className="truncate">{company.name}</span>
        </Link>
    );
}
